(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var secciones = ['cart-drawer', 'cart-icon-bubble'];

    function pintar(estado) {
      var cajon = document.querySelector('cart-drawer');
      if (cajon && estado && estado.sections) {
        cajon.classList.toggle('is-empty', estado.item_count === 0);
        cajon.renderContents(estado);
      }
    }

    function aplicarCodigos(codigos, contenedor) {
      if (contenedor) contenedor.classList.add('is-cargando');
      return fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codigos.join(','), sections: secciones })
      })
        .then(function (r) { return r.json(); })
        .then(function (estado) {
          pintar(estado);
          var malos = (estado.discount_codes || []).filter(function (d) { return !d.applicable; });
          if (!malos.length) return;
          var aviso = document.querySelector('.spc-cupon__error');
          if (aviso) {
            aviso.textContent = 'El código ' + malos[0].code + ' no es válido o no aplica a este pedido.';
            aviso.hidden = false;
          }
          var vigentes = (estado.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: vigentes.join(',') })
          });
        })
        .finally(function () {
          if (contenedor) contenedor.classList.remove('is-cargando');
        });
    }

    function codigosActuales(contenedor) {
      var lista = (contenedor && contenedor.dataset.codigos) || '';
      return lista ? lista.split(',').filter(Boolean) : [];
    }

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('.spc-cupon__form');
      if (!form) return;
      event.preventDefault();
      var contenedor = form.closest('.spc-cupon');
      var codigo = form.codigo.value.trim();
      if (!codigo) return;
      var codigos = codigosActuales(contenedor).filter(function (c) {
        return c.toLowerCase() !== codigo.toLowerCase();
      });
      codigos.push(codigo);
      aplicarCodigos(codigos, contenedor);
    });

    document.addEventListener('click', function (event) {
      var quitar = event.target.closest('.spc-cupon__quitar');
      if (quitar) {
        var contenedor = quitar.closest('.spc-cupon');
        var codigos = codigosActuales(contenedor).filter(function (c) {
          return c !== quitar.dataset.codigo;
        });
        aplicarCodigos(codigos, contenedor);
        return;
      }

      var abrir = event.target.closest('.spc-look__abrir');
      if (abrir) {
        var tarjeta = abrir.closest('.spc-look__tarjeta');
        tarjeta.classList.add('is-abierta');
        abrir.setAttribute('aria-expanded', 'true');
        var primera = tarjeta.querySelector('.spc-look__talla:not([disabled])');
        if (primera) primera.focus({ preventScroll: true });
        return;
      }

      var talla = event.target.closest('.spc-look__talla');
      if (!talla || talla.disabled) return;
      talla.classList.add('is-cargando');
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(talla.dataset.variante), quantity: 1 }], sections: secciones })
      })
        .then(function (r) { return r.json(); })
        .then(function (estado) {
          if (estado.status) {
            talla.classList.remove('is-cargando');
            var error = document.getElementById('CartDrawer-CartErrors');
            if (error) error.textContent = estado.description || estado.message || '';
            return;
          }
          estado.item_count = 1;
          pintar(estado);
        })
        .catch(function () {
          talla.classList.remove('is-cargando');
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var abrir = event.target.closest('.spp-guia-abrir');
    if (abrir) {
      var modal = document.getElementById(abrir.getAttribute('aria-controls'));
      if (modal && typeof modal.showModal === 'function') {
        modal.showModal();
      }
      return;
    }
    var cerrar = event.target.closest('.spp-guia-modal__cerrar');
    if (cerrar) {
      var dlg = cerrar.closest('dialog');
      if (dlg) dlg.close();
      return;
    }
    if (event.target.classList && event.target.classList.contains('spp-guia-modal')) {
      event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
